import React from "react";
import Hero from "@components/landing/Hero";

function Home() {
  return (
    <Hero />
  );
}

export default Home;
